import { createReducer, on } from '@ngrx/store';
import { setRegisterId, resetRegisterId } from './register.actions';

export const initialState = 0;

export const registerReducer = createReducer(
    initialState,
    on(setRegisterId, (_state, { registerId }) => registerId),
    on(resetRegisterId, () => 0),
);
